// Authentication utilities for handling session and redirects

import { baseBackendURL } from "./baseUrl";

export const checkAuthStatus = async () => {
  try {
    const response = await fetch(`${baseBackendURL}/session`, {
      credentials: "include",
    });
    const data = await response.json();
    return {
      isAuthenticated: data.success,
      userData: data.success ? data : null,
    };
  } catch (error) {
    console.error("Error checking auth status:", error);
    return {
      isAuthenticated: false,
      userData: null,
    };
  }
};

export const redirectToHome = () => {
  window.location.href = "/";
};

export const redirectToApp = () => {
  window.location.href = "/app";
};

export const handleAuthError = (error, navigate) => {
  if (
    error.status === 401 ||
    error.message?.includes("401") ||
    error.message?.includes("Unauthorized")
  ) {
    console.log("Session expired, redirecting to home");
    navigate("/");
    return true;
  }
  return false;
};

export const makeAuthenticatedRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      ...options,
      credentials: "include",
    });

    if (response.status === 401) {
      redirectToHome();
      throw new Error("Authentication required");
    }

    return response;
  } catch (error) {
    if (
      error.message?.includes("401") ||
      error.message?.includes("Unauthorized")
    ) {
      redirectToHome();
    }
    throw error;
  }
};
